const STOQ_BUTTON_SELECTOR = '[data-stoq-manual-notify-button]';
const STOQ_PRODUCT_JSON_SELECTOR = '[data-stoq-product-json]';

function getStoqApi() {
  return window._RestockRocket;
}

function readProductData(button) {
  const jsonEl = button.closest('add-to-cart-component')?.querySelector(STOQ_PRODUCT_JSON_SELECTOR);

  if (!jsonEl?.textContent) return null;

  try {
    return JSON.parse(jsonEl.textContent);
  } catch (error) {
    console.warn('Could not parse STOQ product data', error);
    return null;
  }
}

function openWhenReady(callback, attempts = 40) {
  const stoq = getStoqApi();

  if (stoq?.openModal) {
    callback(stoq);
    return;
  }

  if (attempts <= 0) {
    console.warn('STOQ app embed is not available on this page.');
    return;
  }

  window.setTimeout(() => openWhenReady(callback, attempts - 1), 250);
}

function updateButtonForVariant(button, variant) {
  const addToCartButton = button
    .closest('add-to-cart-component')
    ?.querySelector('[data-stoq-add-to-cart-button]');

  if (!variant) {
    button.hidden = true;
    if (addToCartButton instanceof HTMLButtonElement) addToCartButton.hidden = false;
    return;
  }

  const shouldShowNotifyButton = variant.available === false;

  button.dataset.variantId = String(variant.id || '');
  button.hidden = !shouldShowNotifyButton;

  if (addToCartButton instanceof HTMLButtonElement) {
    addToCartButton.hidden = shouldShowNotifyButton;
  }
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest(STOQ_BUTTON_SELECTOR) : null;
  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();

  openWhenReady((stoq) => {
    const productData = readProductData(button);
    const variantId = button.dataset.variantId;

    if (productData && variantId) {
      stoq.openModal(productData, variantId);
    } else {
      stoq.openModal();
    }
  });
});

document.addEventListener('shopify:product:select', (event) => {
  if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;

  const section = event.target.closest('.shopify-section, dialog');
  if (!section) return;

  event.promise
    .then(({ detail }) => {
      if (!detail?.html) return;

      const { html, newProduct, productId, resource: variant } = detail;
      const sourceButton = html.querySelector(STOQ_BUTTON_SELECTOR);
      const sourceProductJson = sourceButton?.closest('add-to-cart-component')?.querySelector(STOQ_PRODUCT_JSON_SELECTOR);

      section.querySelectorAll(STOQ_BUTTON_SELECTOR).forEach((button) => {
        const productForm = button.closest('product-form-component');
        if (!productForm || (!newProduct && productId && String(productId) !== productForm.dataset.productId)) return;

        if (newProduct && sourceButton && sourceProductJson) {
          button.dataset.productId = sourceButton.dataset.productId;
          const productJson = button.closest('add-to-cart-component')?.querySelector(STOQ_PRODUCT_JSON_SELECTOR);
          if (productJson) productJson.textContent = sourceProductJson.textContent;
        }

        updateButtonForVariant(button, variant);

        const stoq = getStoqApi();
        if (stoq?.renderButtonForVariant && variant?.id) {
          stoq.renderButtonForVariant(String(variant.id));
        }
      });
    })
    .catch((error) => {
      // Horizon aborts the previous request when another variant is chosen.
      if (error?.name !== 'AbortError') console.error('Could not update the STOQ notify button', error);
    });
});
